module.exports = __webpack_public_path__ + "i18n/en_7fedb967e8d94fe2dfae49443753dac9.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 154